import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { Close, ArrowDropUp, ArrowDropDown } from "@material-ui/icons";
import IconCheck from "@material-ui/icons/Check";
import {
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import { defaultProps } from "recompose";

export default function SortBy(props) {
  const stopOptions = { price: "Price", duration: "Duration" };

  const handleChange = (val) => {
    if (props.onChange) props.onChange(val.target.value);
  };

  return (
    <FormControl
      sx={{
        "&.MuiFormControl-root": {
          display: "block",
        },
        padding: "0 1rem",
      }}
    >
      <FormLabel
        id="sortby-filter-radio-buttons-group"
        sx={{
          display: "block",
          fontWeight: "700",
          textAlign: "start",
          color: "#000000",
        }}
      >
        Sort By
      </FormLabel>
      <RadioGroup
        aria-labelledby="sortby-filter-radio-buttons-group"
        // name="controlled-radio-buttons-group"
        // value="price"
      >
        {Object.keys(stopOptions).map((option) => (
          <FormControlLabel
            control={
              <Radio
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 14,
                  },
                  "&.Mui-checked": {
                    color: "#00846A",
                  },
                }}
                name={option}
                onChange={handleChange}
                value={option}
              />
            }
            label={stopOptions[option]}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "0.75rem !important",
                color: "#000000",
                fontWeight: 500,
              },
              margin: "0",
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

SortBy.defaultProps = {
  value: "price",
};
